import { Image } from '@components'
import Styled from '@emotion/styled'

export const Avatar = Styled(Image)`
height: 56px;
width: 56px;
radius:50%
`
